import { makeStyles } from "tss-react/mui";

export const useStyle = makeStyles()((theme) => ({
    card: {
        maxWidth: "100% !important",
    },
    divider: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(3),
    },
    address: {
        padding: theme.spacing(1, 1.5),
        backgroundColor: theme.palette.background.main,
        borderRadius: theme.shape.borderRadius,
    },
    deliveryAddressWrapper: {
        marginTop: theme.spacing(2),
    },
}));
